const genericUpdateKeys: Array<keyof ModalsState> = [
  'subscription',
  'userMobileTabs',
  'mobileNav',
  'errorPiecework',
  'notificationBell',
  'profileMenu',
  'deleteAds',
  'confirmation',
  'subscription',
];

export { genericUpdateKeys };
